import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

import { SupplyRegisterService } from '../proxy/planning/controllers/supply-register.service';
import { ThirdPartyPropertyService } from '../proxy/planning/controllers/third-party-property.service';
FieldBuilder.setNamespace('Planning');

export const SUPPLYREGISTERPERTHIRDPARTYPROPERTY_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey('supplyRegisterId', 'Entity.SupplyRegister', SupplyRegisterService)
    .displayFromNested('supplyRegister.number')
    .sortBy('supplyRegister.number')
    .display('number')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey('thirdPartyPropertyId', 'Entity.ThirdPartyProperty', ThirdPartyPropertyService)
    .displayFromNested('thirdPartyProperty.name')
    .sortBy('thirdPartyProperty.name')
    .hideInChildForms()
    .build(),
];

export const SUPPLYREGISTERPERTHIRDPARTYPROPERTY_CONFIG = {
  entityName: 'SupplyRegisterPerThirdPartyProperty',
  localizationKey: 'Planning::Entity.SupplyRegisterPerThirdPartyProperty',
  fields: SUPPLYREGISTERPERTHIRDPARTYPROPERTY_FIELDS,
  permission: 'ControllingContract.SupplyRegisterPerThirdPartyProperties',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
